import React from 'react';

import LoadingPage from '@medipass/react-core/Layout/LoadingPage';
import sdk from '@medipass/web-sdk';

import { getKeyFromQueryParams } from 'legacy/utils/router';

import { AUTH_URL } from '../../constants';
type Props = {
  expiredTokenRedirectUrl?: string;
  children: React.ReactNode;
  isSelfCheckoutSession?: boolean;
  requiresValidAccountToken?: boolean;
  requiresValidSessionToken?: boolean;
};
type State = {
  isAuthenticated: boolean;
};

class WithAuthentication extends React.Component<Props, State> {
  static defaultProps = {
    expiredTokenRedirectUrl: undefined,
    isSelfCheckoutSession: false,
    requiresValidAccountToken: true,
    requiresValidSessionToken: false,
  };
  state = {
    isAuthenticated: false,
  };
  componentDidMount = async () => {
    const { expiredTokenRedirectUrl, isSelfCheckoutSession, requiresValidAccountToken, requiresValidSessionToken } =
      this.props;
    const redirectUrl =
      expiredTokenRedirectUrl ||
      `${AUTH_URL}?forwardTo=${window.location.pathname || ''}${window.location.search || ''}`;

    // @ts-expect-error TS(7006): Parameter 'config' implicitly has an 'any' type.
    sdk.requestInterceptorSuccess = config => {
      if (sdk.hasSessionExpired()) {
        window.location.href = redirectUrl;
      }
    };

    // @ts-expect-error TS(2339): Property 'responseInterceptorFailure' does not exi... Remove this comment to see the full error message
    sdk.responseInterceptorFailure = err => {
      if (err.status === 401) {
        window.location.href = redirectUrl;
      }
    };

    const accountId = getKeyFromQueryParams('accountId');
    const token = getKeyFromQueryParams('token');

    if (token && isSelfCheckoutSession) {
      // Set session token for checkouts
      sdk.setToken(token, 'session');
    } else if (token && accountId) {
      // Log in via token & accountId query params
      sdk.removeStorage();
      sdk.clearTokens();

      try {
        await sdk.auth.loginWithToken(token, accountId);
      } catch (err) {
        window.location.href = redirectUrl;
        return;
      }
    }

    if (requiresValidAccountToken && !sdk.hasValidSession('account')) {
      window.location.href = redirectUrl;
      return;
    }

    if (requiresValidSessionToken && !sdk.hasValidSession('session')) {
      window.location.href = redirectUrl;
      return;
    }

    this.setState({
      isAuthenticated: true,
    });
  };
  render = () => (this.state.isAuthenticated ? this.props.children : <LoadingPage />);
}

export default WithAuthentication;
